module.exports = __webpack_public_path__ + "static/media/sync.c0280088.svg";